const template = require('./template.hbs');
const ScrollableMixin = require('../components/mixins/scrollable');
const EditorFacade = require('../../../facade/editor/editor');
const ElementRestrictions = require('./element-restrictions');
const TemplateRestrictions = require('./template-restrictions');
const RestrictionsFactory = require('../../../factory/restrictions');
const CompanyFactory = require('../../../factory/company').instance;

module.exports = Backbone.mixin(Backbone.View.extend({
  events: {
    'click .template-restrictions div.simplified-template-restrictions-option > input': 'resetRestrictionsEvent',
    'click .reset-restrictions div.template-restrictions-tab': 'toggleRestrictionsTabEvent',
    'click .reset-restrictions div.element-restrictions-tab': 'toggleRestrictionsTabEvent'
  },

  resetRestrictionsEvent: function (event) {
    INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_span', {
      text: INKIVE.TranslateHelper.translate('modal.alert.reset_restrictions')
    }), {
      callback: [
        _.bind(function () {
          RestrictionsFactory.removeAll();
          this.previousRestrictionType = this._findSelectedRestrictionType();
          _.defer(function () { this.applyRestrictionsEvent(event); }.bind(this));
        }, this),
        function () {
          if (this.previousRestrictionType) {
            this.previousRestrictionType.checked = true;
          } else {
            const restrictionTypes = this.el.querySelectorAll('.simplified-template-restrictions-option input');

            for (const restrictionType of restrictionTypes) {
              restrictionType.checked = false;
            }
          }
        }.bind(this)
      ]
    });
  },

  toggleRestrictionsTabEvent: function (event) {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    canvas.clearSelection();

    const isTemplateRestrictionsTab = event.target.classList.contains('template-restrictions-tab');
    this.$el.find('.template-restrictions').toggleClass('hidden', !isTemplateRestrictionsTab);
    this.$el.find('.element-restrictions').toggleClass('hidden', isTemplateRestrictionsTab);
    this.$el.find('.template-restrictions-tab').toggleClass('active', isTemplateRestrictionsTab);
    this.$el.find('.element-restrictions-tab').toggleClass('active', !isTemplateRestrictionsTab);
    if (isTemplateRestrictionsTab) {
      this.show();
    }
  },

  applyRestrictionsEvent: function (event) {
    INKIVE.Modal.loader(this.$el.find('.tab-content'));
    this.toggleRestrictionButtons();
    const type = $(event.currentTarget).is('input')
      ? $(event.currentTarget).data('type')
      : this.selectedRestrictions;

    RestrictionsFactory
      .createGlobalTemplateRestriction(type)
      .then(_.bind(function () {
        RestrictionsFactory.unsavedElementChanges = [];
        RestrictionsFactory.unsavedTemplateChanges = [];
        INKIVE.Modal.loaderClose(this.$el.find('.tab-content'));

        this.toggleAdvancedRestrictions(true);
        this.templateRestrictionsView.renderRestrictions()
          .then(this.elementRestrictionsView.refresh);
        const canvas = INKIVE.Tool.getInstance().editor.canvas;
        canvas.clearSelection();
        const isActive = this.el.querySelector('dt').classList.contains('active');

        if (!isActive) return;

        const animationInput = this.el.querySelector('input[name="function_animation_file"]');
        this.templateRestrictionsView.recalculateSectionHeight(animationInput);
      }, this));
  },

  initialize: function () {
    _.bindAll(this, 'setSelection', 'onInnerViewUpdate');
    this.scrollRefresh = _.debounce(_.bind(this.initScroll, this), 1000);
    document.querySelector('[href="#tabRestrictions"]').parentNode.style.display = '';
    document.querySelector('[href="#tabSimplifiedRestrictions"]')?.parentNode.remove();
  },

  show: function () {
    const isAlreadyThere = this.$el.find('.template-restrictions').length;

    if (isAlreadyThere) {
      this.templateRestrictionsView.renderRestrictions()
        .then(this.elementRestrictionsView.refresh)
        .then(_.bind(this.refreshElementSelection, this));
    } else {
      CompanyFactory.initialize().then(_.bind(this.render, this));
    }
  },

  refreshElementSelection: function () {
    const selectedElements = EditorFacade.get('selection');

    if (selectedElements.length) {
      this.setSelection(selectedElements);
      this.elementRestrictionsView.setSelection(selectedElements);
    }
  },

  render: function () {
    this.$el.html(template());

    INKIVE.Helpers.initTooltips(this.$el);
    INKIVE.Modal.loader(this.$el.find('.tab-content'));

    this.afterLoading = _.after(2, _.once(_.bind(this.afterLoadingAll, this)));
    this.initElementRestrictions();
    this.initTemplateRestrictions();

    EditorFacade.on('select', this.setSelection);
  },

  initTemplateRestrictions: function () {
    this.templateRestrictionsView = new TemplateRestrictions({
      el: this.$el.find('.template-restrictions')
    });

    this.templateRestrictionsView.on('update', this.onInnerViewUpdate);
  },

  initElementRestrictions: function () {
    this.elementRestrictionsView = new ElementRestrictions({
      el: this.$el.find('.element-restrictions')
    });

    this.elementRestrictionsView.on('update', this.onInnerViewUpdate);
    EditorFacade.on('page.move_to', this.elementRestrictionsView.refresh);
  },

  setSelection: function (elements) {
    this.$el.find('.template-restrictions').toggleClass('hidden', true);
    this.$el.find('.element-restrictions').toggleClass('hidden', false);
    this.$el.find('.template-restrictions-tab').toggleClass('active', false);
    this.$el.find('.element-restrictions-tab').toggleClass('active', true);
  },

  onInnerViewUpdate: function () {
    this.afterLoading();
    this.scrollRefresh();
    this.trigger('template-restrictions-updated');
  },

  afterLoadingAll: async function () {
    let permissions = await RestrictionsFactory.getTemplatePermissions();

    INKIVE.Modal.loaderClose(this.el.querySelector('.tab-content'));
    permissions = _(permissions).find(function (p) { return !p.group; });

    if (!permissions) {
      const canvas = INKIVE.Tool.getInstance().editor.canvas;

      await RestrictionsFactory.createGlobalTemplateRestriction('loose');

      INKIVE.Modal.loaderClose(this.el.querySelector('.tab-content'));
      this.toggleAdvancedRestrictions(true);
      this.templateRestrictionsView.renderRestrictions()
        .then(this.elementRestrictionsView.refresh);
      canvas.clearSelection();
    } else {
      this.toggleAdvancedRestrictions(permissions);
      this.templateRestrictionsView.renderRestrictions()
        .then(this.elementRestrictionsView.refresh);
    }

    this.previousRestrictionType = this._findSelectedRestrictionType();
  },

  toggleAdvancedRestrictions: function (value) {
    this.$el.find('.template-restrictions-tab, .element-restrictions-tab, .template-restrictions, .reset-restrictions')
      .toggleClass('hidden', !value);

    this.$el.find('.element-restrictions-tab')
      .toggleClass('active', !value);
  },

  toggleRestrictionButtons: function () {
    const restrictionButtons = document.querySelectorAll('button.webrand[data-popover="tooltip"]');
    restrictionButtons.forEach(button => button.classList.toggle('hide'));
  },

  _findSelectedRestrictionType: function () {
    const restrictionTypes = this.el.querySelectorAll('.simplified-template-restrictions-option input');

    for (const restrictionType of restrictionTypes) {
      if (restrictionType.checked) return restrictionType;
    }

    return null;
  },
}), ScrollableMixin);
